import { useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { BackgroundColorContainer, MainDiv } from 'components/styles_components/container';
import { isAuthenticated } from 'utils/authentication';
import { useSpace } from 'contexts/space';
import { SpacesLink } from 'utils/link';
import SideMenu from 'components/layout/side_menu';
import Footer from 'components/layout/footer';
import TopMenu from 'components/layout/top_menu';
import MainContainer from 'components/layout/main_container';
import useMobile from 'hooks/use_mobile';
import theme from 'theme';

const PrivateRoute = () => {
  const isMobile = useMobile();
  const [sidebarVisible, setSidebarVisible] = useState(!isMobile);
  const style = sidebarVisible && !isMobile ? { marginLeft: theme.width.sideMenu } : {};
  const { currentSpaceId } = useSpace();

  if (!isAuthenticated()) {
    return <Navigate to="/users/login" />;
  }

  if (!currentSpaceId) {
    return <Navigate to={SpacesLink()} />;
  }

  return (
    <>
      <TopMenu
        sidebarVisible={sidebarVisible}
        setSidebarVisible={setSidebarVisible}
      />
      <BackgroundColorContainer>
        <MainDiv style={style}>
          <SideMenu
            visible={sidebarVisible}
            fullWidth={isMobile && sidebarVisible}
            hideMenu={() => {
              setSidebarVisible(false);
            }}
          />
          <MainContainer>
            <Outlet />
          </MainContainer>
        <Footer />

        </MainDiv>
      </BackgroundColorContainer>
    </>
  );
};

export default PrivateRoute;
